export const cleanPhoneNumber = (phoneNumber: string): string => {
  const startsWithPlus = phoneNumber.startsWith('+');
  let cleaned = phoneNumber.replace(/\D/g, '');
  if (startsWithPlus) {
    cleaned = '+' + cleaned;
  }
  return cleaned;
};

// Strips the +1 country code from an E.164 US/Canada number so PatternFormat
// components using format="+1 (###) ###-####" receive the expected 10 digits.
export const stripE164CountryCode = (value: string): string =>
  /^\+1\d{10}$/.test(value) ? value.slice(2) : value;
